import type {
  WishlistToken,
  WishlistState,
  WishlistState_Item,
} from "../../aysa_api/models/wishlist.types";
import { Reader, Writer } from "protobufjs/minimal";
import type { Long } from "protoc-gen-ts";

export const createBaseWishlistToken = (): WishlistToken => {
  return {
    token: new Uint8Array(),
    hash: 0,
  };
};

export const decodeWishlistToken = (
  reader: Reader,
  length: number
): WishlistToken => {
  const end = reader.pos + length;
  const message = createBaseWishlistToken();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.token = reader.bytes();

        break;
      case 2:
        message.hash = reader.int32();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeWishlistToken = (
  writer: Writer,
  message: WishlistToken
): Writer => {
  writer.uint32(10).bytes(message.token);
  writer.uint32(16).int32(message.hash);

  return writer;
};

export const createBaseWishlistState = (): WishlistState => {
  return {
    items: [],
    token: createBaseWishlistToken(),
  };
};

export const decodeWishlistState = (
  reader: Reader,
  length: number
): WishlistState => {
  const end = reader.pos + length;
  const message = createBaseWishlistState();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.items.push(decodeWishlistState_Item(reader, reader.uint32()));

        break;
      case 3:
        message.token = decodeWishlistToken(reader, reader.uint32());

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeWishlistState = (
  writer: Writer,
  message: WishlistState
): Writer => {
  for (const value of message.items) {
    encodeWishlistState_Item(writer.uint32(10).fork(), value).ldelim();
  }
  encodeWishlistToken(writer.uint32(26).fork(), message.token).ldelim();

  return writer;
};

export const createBaseWishlistState_Item = (): WishlistState_Item => {
  return {
    productId: 0,
  };
};

export const decodeWishlistState_Item = (
  reader: Reader,
  length: number
): WishlistState_Item => {
  const end = reader.pos + length;
  const message = createBaseWishlistState_Item();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.productId = (reader.int64() as Long).toNumber();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeWishlistState_Item = (
  writer: Writer,
  message: WishlistState_Item
): Writer => {
  writer.uint32(8).int64(message.productId);

  return writer;
};
